<template>
  <div class="grid-container align-center">
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </div>
</template>
<script setup>
import { ExperimentationTags } from '@nuxt-common/util/app/utils/experimentation';
import { loadTagLibrary } from '@nuxt-common/util/app/utils/tagManager';
import sessionTimeoutHandler from '../app/utils/sessionTimeoutHandler';
import { headLinks } from '#utils/headLinks.js';
const envPropsStore = useEnvPropsStore();

useHead(() => ({
  link: headLinks,
}));

onMounted(async () => {
  sessionTimeoutHandler();
  // Defer non-critical analytics and third-party scripts to yield the main thread.
  const runIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

  runIdle(async () => {
    loadTagLibrary(import.meta.env.VITE_ENTRY_POINT, envPropsStore.envProps.tagManagerEnv, true);
    await ExperimentationTags.fireAdobeTags();
  });
});

const pageDataStore = usePageDataStore();

useHead(() => ({
  title: pageDataStore.pageData?.title,
}));
</script>
